<template>
  <woot-modal :show.sync="show" :on-close="onClose">
    <div class="new-internal-chat">
      <woot-modal-header
        :header-title="$t('INTERNAL_CHAT.NEW_CHAT_MODAL.TITLE')"
      />
      <div class="new-internal-chat__body">
        <woot-input
          v-model="search"
          :placeholder="$t('INTERNAL_CHAT.NEW_CHAT_MODAL.SEARCH_PLACEHOLDER')"
        />
        <p
          v-if="!filteredCollaborators.length"
          class="new-internal-chat__empty"
        >
          {{ $t('INTERNAL_CHAT.NEW_CHAT_MODAL.NO_RESULTS') }}
        </p>
        <ul v-else class="new-internal-chat__list">
          <li
            v-for="collaborator in filteredCollaborators"
            :key="collaborator.id"
            class="new-internal-chat__item"
            @click="$emit('start', collaborator.id)"
          >
            <woot-thumbnail
              :src="collaborator.thumbnail"
              :username="collaborator.name"
              size="32px"
            />
            <div class="new-internal-chat__item-content">
              <span class="new-internal-chat__item-name">{{
                collaborator.name
              }}</span>
              <span class="new-internal-chat__item-email">{{
                collaborator.email
              }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </woot-modal>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: '',
    };
  },
  computed: {
    ...mapGetters({
      agents: 'agents/getAgents',
      currentUserId: 'getCurrentUserID',
    }),
    collaborators() {
      return this.agents.filter(agent => agent.id !== this.currentUserId);
    },
    filteredCollaborators() {
      const query = this.search.trim().toLowerCase();
      if (!query) {
        return this.collaborators;
      }

      return this.collaborators.filter(
        collaborator =>
          collaborator.name.toLowerCase().includes(query) ||
          (collaborator.email || '').toLowerCase().includes(query)
      );
    },
  },
  mounted() {
    this.$store.dispatch('agents/get');
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.new-internal-chat__body {
  padding: 0 var(--space-normal) var(--space-normal);
}

.new-internal-chat__empty {
  color: var(--s-500);
  margin-top: var(--space-normal);
}

.new-internal-chat__list {
  list-style: none;
  margin: var(--space-small) 0 0;
  padding: 0;
  max-height: 30rem;
  overflow-y: auto;
}

.new-internal-chat__item {
  display: flex;
  align-items: center;
  gap: var(--space-small);
  padding: var(--space-small);
  cursor: pointer;
  border-radius: var(--border-radius-normal);

  &:hover {
    background: var(--color-background-light);
  }
}

.new-internal-chat__item-content {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.new-internal-chat__item-name {
  font-weight: var(--font-weight-medium);
}

.new-internal-chat__item-email {
  font-size: var(--font-size-mini);
  color: var(--s-500);
}
</style>
